import { forwardRef, useContext } from 'react'
import { ChipsActionComponent } from '../styled-components'
import { ChipsContext } from './chips-context'

const ChipsAction = forwardRef(({ children, ...props }, fowardedRef) => {
  const context = useContext(ChipsContext)

  return (
    <ChipsActionComponent
      ref={fowardedRef}
      aria-selected={context.selected}
      {...props}
      {...context}
    >
      {children}
    </ChipsActionComponent>
  )
})

ChipsAction.displayName = 'ChipsAction'

export default ChipsAction
